// extracted by mini-css-extract-plugin
module.exports = {"option":"styles_option_3FxVWh6pJHSkdn4I60FV9t","icon":"styles_icon_22EX-3K8d3p-JH7I0rGKhT","label":"styles_label_3Gd0XobOfbt6kG2mSnl_tl"};